const servers = {
    //PRO
    "practicasacademicas.nebrija.es": "https://gestiondcp.nebrija.es",
    //PRE
    "tutores-nebrija.dev.doubledot.es": "https://sandbox-nebrija.dotia.es",
    //LOCAL
    "localhost:8080": "https://sandbox-nebrija.dotia.es",
}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js